import { Injectable } from '@angular/core';
import {Subject} from 'rxjs';

@Injectable()
export class LoadingService {
    showLoading = new Subject();
    constructor() {
    }
}
